var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Children, cloneElement, isValidElement } from 'react';
import { mergeProps } from '@react-aria/utils';
import { useFocusRing } from '@react-aria/focus';
import { cardStyle, decorStyle, headstoneStyle } from './styles';
function CardInternal(_a, ref) {
    var as = _a.as, children = _a.children, headstone = _a.headstone, _b = _a.variant, variant = _b === void 0 ? 'regular' : _b, _c = _a.highlightVariant, highlightVariant = _c === void 0 ? 'green' : _c, _d = _a.highlightPlacement, highlightPlacement = _d === void 0 ? 'left' : _d, _e = _a.disableHoverEffect, disableHoverEffect = _e === void 0 ? false : _e, _f = _a.inverted, inverted = _f === void 0 ? false : _f, restProps = __rest(_a, ["as", "children", "headstone", "variant", "highlightVariant", "highlightPlacement", "disableHoverEffect", "inverted"]);
    var Element = as || 'section';
    var _g = useFocusRing(), focusProps = _g.focusProps, isFocusVisible = _g.isFocusVisible;
    function renderHeadstone() {
        return Children.map(headstone, function (headstoneItem) {
            if (isValidElement(headstoneItem)) {
                if (inverted) {
                    return cloneElement(headstoneItem, {
                        inverted: inverted,
                    });
                }
                return headstoneItem;
            }
            return null;
        });
    }
    return (_jsxs(Element, __assign({}, mergeProps(focusProps, restProps), { ref: ref, css: cardStyle({
            isFocusVisible: isFocusVisible,
            hasHeadstone: !!headstone,
            disableHoverEffect: disableHoverEffect,
            inverted: inverted,
        }) }, { children: [headstone && _jsx("div", __assign({ css: headstoneStyle() }, { children: renderHeadstone() })), variant === 'highlight' && (_jsx("div", { css: decorStyle({ highlightVariant: highlightVariant, highlightPlacement: highlightPlacement }) })), children] })));
}
export default CardInternal;
